// extracted by mini-css-extract-plugin
export default {"main":"Login_main__svIsx","form":"Login_form__HoQ6M","errorMessage":"Login_errorMessage__C8kjY"};